import { Unit } from '@appbolaget/aware-model';

export class SetActiveUnit {
    static readonly type = '[Unit service] Set active unit';
    constructor(public unit: Unit) {}
}

export class SetActiveUnitIfNotSet {
    static readonly type = '[Unit state] Set active unit if not set';
    constructor(
        public available_units: Unit[],
        public isGod?: boolean,
    ) {}
}

export class GetMyScopedUnits {
    static readonly type = '[Unit state] Get my scoped units';
}

export class GetNavigation {
    static readonly type = '[Unit state] Get navigation';
}
